export const T = {
  en_GB: {
    remove: "Remove",
    description: "Description",
    descriptionPlaceholder: "Description...",
    amountPlaceholder: "Amount...",
    amount: "Amount",
    monthly: "Monthly",
    type: "Type",
  },
  nb_NO: {
    remove: "Fjern",
    description: "Beskrivelse",
    descriptionPlaceholder: "Beskrivelse...",
    amountPlaceholder: "Beløp...",
    amount: "Beløp",
    monthly: "Månedlig",
    type: "Type",
  },
} as const;
